module.exports = __webpack_public_path__ + "img/Schroepfen_farbig.5bc0215.svg";